<template>
  <TeaserAccountTile>
    <template v-slot:component>
      <PublicPasswordResetContainer></PublicPasswordResetContainer>
    </template>
    <template v-if="loggedIn" v-slot:image>
      <TeaserResetPassword></TeaserResetPassword>
    </template>
  </TeaserAccountTile>
</template>

<script setup lang="ts">
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'
import TeaserResetPassword from '@/componentsTenant/rahmen/images/TeaserResetPassword.vue'
import { isAuthenticated } from '@/utils/KeycloakUtils'
import PublicPasswordResetContainer from '@/components/account-management/publicpasswordreset/PublicPasswordResetContainer.vue'
import { onMounted, ref } from 'vue'

const loggedIn = ref(false)
onMounted(() => {
  loggedIn.value = isAuthenticated()
})
</script>
